import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppSplashComponent } from './shared/components/ui/app-splash/app-splash.component';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    AppSplashComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  // Exposed for the template — controls whether the splash is shown during
  // the silent-refresh + /me boot phase (avoids `/signin` flash on reload).
  readonly auth = inject(AuthService);

  title = 'Nawam Owner';
}
